<template>
  <div class="component">
    <div>
      <TooltipSlot :text="'Sluit'">
        <div @click="$store.commit('opdracht/close')" class="button">
          <svg focusable="false" data-prefix="fas" data-icon="xmark" class="svg-inline--fa fa-xmark fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"></path></svg>
        </div>
      </TooltipSlot>
      <TooltipSlot :text="'Minimaliseer [cmd+d]'">
        <div class="button" @click="$store.commit('opdracht/toggleMinimize')">
          <svg :class="{ rotated180: minimized }" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="down-to-line" class="svg-inline--fa fa-down-to-line fa-w-12" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M352 416H31.1C14.33 416 0 430.3 0 447.1S14.33 480 31.1 480H352C369.7 480 384 465.7 384 448S369.7 416 352 416zM328 192.1L256 192.1V64.03c0-17.69-14.33-32.02-32-32.02H160c-17.67 0-32 14.34-32 32.02v128.1L56 192.1c-9.578 0-18.25 5.708-22.05 14.51C30.17 215.4 31.97 225.7 38.55 232.6l136 144.1c9.062 9.601 25.84 9.601 34.91 0l136-144.1c6.578-6.974 8.375-17.2 4.594-26C346.3 197.8 337.6 192.1 328 192.1z"></path></svg>
        </div>
      </TooltipSlot>
      <h2>
        <span style="opacity: 0.3">CDT.{{ new Date(opdracht.metadata.createdAt.toDate()).getFullYear() }}.{{ new Date(opdracht.metadata.createdAt.toDate()).getMonth() + 1 }}.</span>{{ opdracht.metadata.opdrachtNummer }}
      </h2>
    </div>

    <div>
      <div v-if="showMoreOptions" class="extrabuttons">
        <button @click="$emit('archiveer')">Archiveer opdracht</button>
        <button @click="$emit('duplicate')">Dupliceer opdracht</button>
      </div>
      <div class="dotsMenu" @click="showMoreOptions = !showMoreOptions">
        <svg v-if="!showMoreOptions" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ellipsis-vertical" class="svg-inline--fa fa-ellipsis-vertical fa-w-4" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 512"><path fill="currentColor" d="M128 64c0-35.39-28.62-64-64-64S0 28.61 0 64s28.62 64 64 64S128 99.39 128 64zM128 256c0-35.39-28.62-64-64-64S0 220.6 0 256s28.62 64 64 64S128 291.4 128 256zM128 448c0-35.39-28.62-64-64-64s-64 28.61-64 64s28.62 64 64 64S128 483.4 128 448z"></path></svg>
        <svg v-else aria-hidden="true" focusable="false" data-prefix="fas" data-icon="xmark" class="svg-inline--fa fa-xmark fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"></path></svg>
      </div>
    </div>
  </div>
</template>

<script>
import TooltipSlot from "@/components/v2/interactions/TooltipSlot"
export default {
  props: ["opdracht", "minimized"],
  data() {
    return {
      showMoreOptions: false
    }
  },
  components: { TooltipSlot }
}
</script>

<style lang="sass" scoped>

.extrabuttons
  button
    -webkit-appearance: none
    border: none
    outline: none
    padding: 11px 14px
    margin-right: 10px
    border-radius: 5px
    font-family: 'manrope'
    background-color: black
    color: white
    font-weight: 500

.component
  background-color: white
  width: calc( 100% - 320px )
  display: flex
  align-items: center
  padding: 10px
  position: relative
  justify-content: space-between
  > div
    display: flex
    align-items: center

  .dotsMenu
    width: 40px
    height: 40px
    border-radius: 100%
    display: flex
    align-items: center
    justify-content: center
    cursor: pointer
    transition: .2s
    svg
      opacity: .4
      height: 20px
    &:hover
      background-color: rgba(0, 0, 0, 0.04)

  h2
    margin-left: 14px
    font-weight: 600
    font-size: 18px


  .button
    // border: 1px solid rgba(0, 0, 0, 0.05)
    $size: 30px
    width: $size
    height: $size
    display: flex
    align-items: center
    justify-content: center
    border-radius: 4px
    cursor: pointer
    transition: .2s
    padding: 0
    // background-color: rgba(0, 0, 0, 0.04)
    &:hover
      background-color: rgba(0, 0, 0, 0.1)
    svg, path
      fill: rgba(0, 0, 0, 0.4)
      height: 16px
      &.rotated180
        transform: rotate(180deg)
</style>
